/**
 * Color Description Switcher
 * Dynamically shows/hides product descriptions based on selected color swatch
 */
(function() {
  'use strict';
  
  // Convert color option value to CSS class name
  function colorToClass(colorName) {
    return colorName.toLowerCase()
      .replace(/\s+&\s+/g, '-')
      .replace(/\s+/g, '-');
  }
  
  // Show specific color description and hide others
  function showColorDescription(colorName) {
    const className = colorToClass(colorName);
    const descriptionContainer = document.querySelector('.product__description-content');
    
    if (!descriptionContainer) return;
    
    // Remove active class from all color descriptions
    const allDescriptions = descriptionContainer.querySelectorAll('.azure-flax, .cobalt-skye, .slate-flax, .sage-blush');
    allDescriptions.forEach(desc => desc.classList.remove('active'));
    
    // Add active class to the selected color description
    const targetDescription = descriptionContainer.querySelector('.' + className);
    if (targetDescription) {
      targetDescription.classList.add('active');
    } else {
      console.warn('Color description not found for:', colorName, 'class:', className);
    }
  }
  
  // Initialize color description switcher
  function initColorDescriptionSwitcher() {
    // Get all color swatch buttons
    const swatchButtons = document.querySelectorAll('[data-swatch-button="true"]');
    
    if (swatchButtons.length === 0) {
      console.warn('No color swatch buttons found');
      return;
    }
    
    // Add click event listeners to all swatch buttons
    swatchButtons.forEach(button => {
      button.addEventListener('click', function() {
        const colorName = this.getAttribute('data-option-value');
        if (colorName) {
          showColorDescription(colorName);
        }
      });
    });
    
    // Initialize with the currently selected color
    const selectedSwatch = document.querySelector('[data-swatch-button="true"].selected');
    if (selectedSwatch) {
      const selectedColor = selectedSwatch.getAttribute('data-option-value');
      if (selectedColor) {
        showColorDescription(selectedColor);
      }
    } else {
      // Fallback: show first available color description
      const firstSwatch = swatchButtons[0];
      if (firstSwatch) {
        const firstColor = firstSwatch.getAttribute('data-option-value');
        if (firstColor) {
          showColorDescription(firstColor);
        }
      }
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorDescriptionSwitcher);
  } else {
    initColorDescriptionSwitcher();
  }
})();

